import React from "react";

import Carousel from "nuka-carousel";

import { Divider } from "../img";

import "../css/testimonials.css";
const Testimonials = () => {
  const letters = [
    {
      msg: "Message Number 1 Content...",
      img: "Img Number 1 Url",
      name: "John Doe",
      role: "CEO of Bla Bla",
    },
    {
      msg: "Message Number 2 Content...",
      img: "Img Number 2 Url",
      name: "John Doe",
      role: "CEO of Bla Bla",
    },
    {
      msg: "Message Number 3 Content...",
      img: "Img Number 3 Url",
      name: "John Doe",
      role: "CEO of Bla Bla",
    },
  ];

  const customClassNames = {
    nextButtonClassName: "slideNext",
	nextButtonText:  "▶",
	
    prevButtonClassName: "slidePrev",
	prevButtonText:  "◀",
	
    pagingDotsContainerClassName: "SlideDotsContainer",
    pagingDotsClassName: "SlideSingleDot"
  };

  return (
    <section className="testimonial" id="testimonial">
      <h1>My Happy Clients</h1>
      <img src={Divider} alt="wavy line" className="divider" />

      <Carousel
	  	speed={1500}
        autoplay={true}
        animation="zoom"
        framePadding="0"
        wrapAround={true}
		    cellAlign="center"
        autoGenerateStyleTag={false}
        defaultControlsConfig={customClassNames}
      >
        {letters.map((letter, i) => {
          const { msg, name, role } = letter;

          return (
            <span className="slider-slide" key={i}>
              <div className="txtBox">
                <h1>“</h1>
                <h3>{msg}</h3>
              </div>

              <div className="border"></div>

              <div className="img"></div>
              {/* <img src={img} alt={name} /> */}

              <h2>{name}</h2>

              <h4>{role}</h4>
            </span>
          );
        })}
      </Carousel>
    </section>
  );
};

export default Testimonials;